/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ListAnalyticsRequestAllOf { 
    /**
     * Return both analytics and subfolders (all), only subfolders (folders), or only analytics (analytics).
     */
    entry_kind?: ListAnalyticsRequestAllOf.EntryKindEnum;
    /**
     * When omitted or null, list root-level analytics (no folder) and root-level folders. When set, list items inside that folder (must be owned by the caller).
     */
    parent_folder_id?: string | null;
}
export namespace ListAnalyticsRequestAllOf {
    export type EntryKindEnum = 'all' | 'folders' | 'analytics';
    export const EntryKindEnum = {
        All: 'all' as EntryKindEnum,
        Folders: 'folders' as EntryKindEnum,
        Analytics: 'analytics' as EntryKindEnum
    };
}


